async function reflectToHash(element, url) {
    const stateMapper = await element.stateMapper;
    const hash = `${stateMapper.getStatePath(url)}`;
    if (hash !== document.location.hash) {
        document.location.hash = hash;
    }
}
async function reflectToHistory(element, resourceUrl) {
    if (resourceUrl !== element.__history.state) {
        const stateMapper = await element.stateMapper;
        const path = stateMapper.getStatePath(resourceUrl);
        let stateUrl;
        if (element.clientBasePath) {
            stateUrl = `${document.location.origin}/${element.clientBasePath}${path}`;
        }
        else {
            stateUrl = `${document.location.origin}${path}`;
        }
        if (!element.__history.state) {
            element.__history.replaceState(resourceUrl, '', stateUrl);
        }
        else {
            element.__history.pushState(resourceUrl, '', stateUrl);
        }
    }
}
function createMixinFor(desiredTarget) {
    const actualTarget = !window.history ? 'hash' : desiredTarget;
    return function ReflectedInHash(Base) {
        class Mixin extends Base {
            constructor(...args) {
                super(args);
                this.__history = window.history;
            }
            // eslint-disable-next-line class-methods-use-this
            get usesHashFragment() {
                return actualTarget === 'hash';
            }
            reflectUrlInState(url) {
                if (actualTarget === 'history') {
                    return reflectToHistory(this, url);
                }
                return reflectToHash(this, url);
            }
            onResourceUrlChanged(newUrl) {
                return this.reflectUrlInState(newUrl);
            }
        }
        return Mixin;
    };
}
export const ReflectedInHash = createMixinFor('hash');
export const ReflectedInHistory = createMixinFor('history');
